import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Settings from "./Component/Settings";
import HomePage from "./Component/HomePage";
import Navbar from "./Component/Navbar";
import Friends from "./Component/Friends";
import Groups from "./Component/Groups";
import Modal from "./Component/Modal";
import PromiseComponent from "./Component/PromiseComponent";
//import LoginForm from "./Component/LoginForm";
import RegisterForm from "./Component/RegisterForm";
import ResetPassword from "./Component/ResetPassword";
import Messaging from "./Component/Messaging";
import { io } from "socket.io-client"
import Jason from "./Component/JasonProfile";
import Login from "./Component/Login"
import Profile from "./Component/Profile";
import Discover from "./Component/Discover"
import ProfilePublic from "./Component/ProfilePublic";
import Followers from './Component/Followers';
import Following from './Component/Following';
import ProfilePageList from "./Component/ProfilePageList";
import KevinProfilePage from "./Component/ProfilePages/KevinProfilePage";
import AdavitaProfilePage from "./Component/ProfilePages/AdavitaProfilePage";
import MichelleProfilePage from "./Component/ProfilePages/MichelleProfilePage"
import NeemProfile from "./Component/ProfilePages/NeemProfile";
import Landing_Modal from "./Component/Landing_Modal";
// import Example from "./Component/Example"
import Feed from "./Component/Feed"
import Post from "./Component/Post"
import PostForm from "./Component/PostForm"
import PostingList from "./Component/PostingList"
import Posts from "./Component/Posts"
import StyleGuidePage from "./Component/StyleGuide";
import PrivacyPage from "./Component/PrivacyPage";
import Blocked from "./Component/Blocked";
import Requests from "./Component/Requests";
import NotFound from './Component/NotFound';
import FindPlayers from './Component/FindPlayers';
import ProfilePagePosts from "./Component/ProfilePagePosts";
import Community from "./Component/Community";
import ViewPost from "./Component/ViewPost";
import Rankings from "./Component/Rankings";


// App.jsx is the starting point for the application.  This is the component called by index, which will be rendered when
// a user goes to your app URL.  This component will handle routing to other parts of your app, and any initial setup.

// Initalize the socket with the respective path and tenantID
// NEED this in App.jsx to use the socket throughout the application for real-time connections
const socket = io(process.env.REACT_APP_API_PATH_SOCKET, {
  path: '/hci/api/realtime-socket/socket.io',
  query: {
    tenantID: "example"
  }
})
export { socket }

function App() {
  
  // logged in state, which tracks the state if the user is currently logged in or not
  // initially set to false
  const [loggedIn, setLoggedIn] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [refreshPosts, setRefreshPosts] = useState(false);

  // basic logout function, removes token and user id from session storage
  const logout = (e) => {
    e.preventDefault();
    sessionStorage.removeItem("token");
    sessionStorage.removeItem("user");
    setLoggedIn(false);
    // reloads the window, so we get back to the login form
    window.location.reload();
  };

  //const login = (e) => {
  //  e.preventDefault();
  //  setRefreshPosts(true);
  //  setLoggedIn(true);
  //};

  const doRefreshPosts = () => {
    console.log("CALLING DOREFRESHPOSTS IN APP.JSX");
    setRefreshPosts(true);
  };

  const toggleModal = (e) => {
    e.preventDefault();
    // Take the current state of openModal, and update it to be the negated value of that
    // ex) if openModal == false, this will update openModal to true
    setOpenModal((prev) => !prev);
    console.log(openModal);
  };

  useEffect(() => {
    socket.on("connect", () => {
      console.log("Connected to HCI socket server")
    })
  }, [])

  return (
    // the app is wrapped in a router component, that will render the
    // appropriate content based on the URL path.  Since this is a
    // single page app, it allows some degree of direct linking via the URL
    // rather than by parameters.  Note that the "empty" route "/", uses the HomePage
    // component, if you look in the HomePage component you will see a ternary operation:
    // if the user is logged in, show the "home page", otherwise show the login form.
    <Router basename={process.env.PUBLIC_URL}>
      <div className="App">
        {/* <header className="App-header">
          <Navbar
            toggleModal={(e) => toggleModal(e)}
            logout={(e) => logout(e)}
          /> */}
          <div className="maincontent" id="mainContent">
            <Routes>
              <Route path="/settings" element={<Settings />} />
              <Route
                path="/"
                element={
                  <Landing_Modal
                    setLoggedIn={setLoggedIn}
                    doRefreshPosts={doRefreshPosts}
                    appRefresh={refreshPosts}
                  />
                }
              />
              <Route
                path="/register"
                element={<RegisterForm setLoggedIn={setLoggedIn} />}
              />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/friends" element={<Friends />} />
              <Route path="/groups" element={<Groups />} />
              <Route path="/promise" element={<PromiseComponent />} />
              <Route path="/Login" element={<Login setLoggedIn={setLoggedIn} />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/discover" element={<Discover />} />
              {/* <Route path="/example" element={<Example />} /> */}

              <Route path="/games/*" element={<Community appRefresh={refreshPosts}/>} />
              {/* <Route path="/games/moba" element={<MOBA appRefresh={refreshPosts}/>} />
              <Route path="/games/fps" element={<FPS appRefresh={refreshPosts}/>} />
              <Route path="/games/battle-royale" element={<BattleRoyale appRefresh={refreshPosts}/>} />
              <Route path="/games/action-adventure" element={<ActionAdventure appRefresh={refreshPosts}/>} />
              <Route path="/games/sandbox" element={<Sandbox appRefresh={refreshPosts}/>} /> */}
              
              <Route path="/feed" element={<Feed appRefresh={refreshPosts}/>} />
              {/* Declaring a route with a URL parameter "roomID" so that React router dynamically 
              captures the corresponding values in the URL when there is a match. 
              It is useful when dynamically rendering the same component for multiple paths.
              You can see how this is used in the Messaging component
              as well as how this path is being set up in the FriendList component */}
              <Route path="/messages/:roomID" element={<Messaging />} />
              <Route path="/user/:userID" element={<ProfilePublic appRefresh={refreshPosts}/>} />
              <Route path="/user/:userID/followers" element={<Followers />} />
              <Route path="/user/:userID/following" element={<Following />} />
              <Route path="/user/:userID/blocked" element={<Blocked />} />
              <Route path="/userPosts" element={<ProfilePagePosts appRefresh={refreshPosts} />} />
              <Route path="/user/:userID/requests" element={<Requests />} />

              <Route path='/profilePageList' element={<ProfilePageList />} />
              <Route path='/KevinProfilePage' element={<KevinProfilePage />} />
              <Route path='/AdavitaProfilePage' element={<AdavitaProfilePage />} />
              <Route path='/MichelleProfilePage' element={<MichelleProfilePage/>} />
              <Route path='/NeemProfilePage' element={<NeemProfile />} />
              <Route path="/JasonProfilePage" element={<Jason />} />

              <Route path="/landing" element={<Landing_Modal />} />
              <Route path="/post" element={<Post />} />
              <Route path="/rankings" element={<Rankings />} />
              <Route path="/postform" element={<PostForm />} />
              <Route path="/postinglist" element={<PostingList />} />
              <Route path="/posts" element={<Posts />} /> 
              <Route path="/StyleGuidePage" element={<StyleGuidePage />} />
              <Route path="/Privacy" element={<PrivacyPage />} />
              <Route path="/Find-Players" element={<FindPlayers />} />
              <Route path="/ViewPost/:PostID" element={<ViewPost />} />
              <Route path="*" element={<NotFound />} />

            </Routes>
          </div>
        {/* </header> */}

        <Modal show={openModal} onClose={(e) => toggleModal(e)}>
          This is a modal dialog!
        </Modal>
      </div>
      
    </Router>
  );
}
export default App;

